export enum StaffMembersDataHooks {
  STAFF_MEMBER = 'booking-details-staff-member',
}
